import styled from "styled-components";

export const ExpandGalleryButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
`;

export const ExpandGalleryButton = styled.button`
  height: 42px;
  font-size: 14px;
  width: 40%;
  border: none;
  background-color: rgb(123, 190, 119);
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  border: 1px solid rgb(231, 231, 231);
  color: white;
  border-radius: 10px;

  &:hover {
    cursor: pointer;
    background-color: rgb(145, 213, 141);
    transition: all 0.1s ease 0s;
  }

  @media screen and (max-width: 992px) {
    width: 100%;
    margin: 1%;
  }
`;
